module.exports = __webpack_public_path__ + "img/fenstergitter.e1d95e7d.webp";